import type { GameView, PrivatePlayerState } from '@secretnenshi/shared';
import { HoldToReveal } from '../components/HoldToReveal';
import { useStore } from '../state/store';
import { useTheme } from '../theme/useTheme';
import { nameOf, type Copy } from './copy';

/** Spec §45: text only, identical styling for every role. */
function IdentityText({ priv, view, c }: { priv: PrivatePlayerState; view: GameView; c: Copy }) {
  const nenshi = priv.knownNenshiPlayerId;
  const allies = (priv.knownFederalistPlayerIds ?? []).filter((id) => id !== nenshi);
  return (
    <>
      <p className="reveal-name">{c.characterName(priv.characterId)}</p>
      <p className="reveal-faction">{c.faction(priv.faction)}</p>
      {allies.length ? (
        <div className="reveal-block">
          <p className="reveal-label">Allies</p>
          {allies.map((id) => (
            <p key={id}>{nameOf(view, id)}</p>
          ))}
        </div>
      ) : null}
      {nenshi ? (
        <div className="reveal-block">
          <p className="reveal-label">{c.t.leader.name}</p>
          <p>{nameOf(view, nenshi)}</p>
        </div>
      ) : null}
      {priv.investigationResults?.length ? (
        <div className="reveal-block">
          <p className="reveal-label">{c.t.powers.CAMPAIGN_RESEARCH.name}</p>
          {priv.investigationResults.map((r) => (
            <p key={r.playerId}>
              {nameOf(view, r.playerId)}: {c.faction(r.faction)}
            </p>
          ))}
        </div>
      ) : null}
    </>
  );
}

/** The persistent control (spec §44). Looks the same for everyone. */
export function MyIdentity({ big = false }: { big?: boolean }) {
  const priv = useStore((s) => s.priv);
  const view = useStore((s) => s.view);
  const c = useTheme();
  return (
    <HoldToReveal label="My identity" hint={big ? 'Hold to reveal' : 'Press and hold'} className={big ? 'hold-big' : 'hold-dock'}>
      {() => (priv && view ? <IdentityText priv={priv} view={view} c={c} /> : <p>Loading…</p>)}
    </HoldToReveal>
  );
}
